import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
} from 'react';
import { Button } from '../../../../components/Button/Button';
import { Modal, ModalRef } from '../../../../components/Modal/Modal';
import { useLanguage } from '../../../../locale/useLanguage';

type ConfirmDeliveryTimeModalProps = {
  range?: string;
  date: string;
  onConfirm: () => void;
};

export const ConfirmDeliveryTimeModal: React.ForwardRefExoticComponent<
  ConfirmDeliveryTimeModalProps & React.RefAttributes<ModalRef>
> = forwardRef(({ range, date, onConfirm }, forwardedRef) => {
  const [t] = useLanguage();
  const modalRef = useRef<ModalRef>(null);
  const hours = range ? range.split('/') : '';

  useImperativeHandle(forwardedRef, () => ({
    openModal: modalRef.current!.openModal,
    closeModal: modalRef.current!.closeModal,
  }));

  const close = useCallback(() => {
    modalRef.current?.closeModal();
  }, []);

  return (
    <Modal ref={modalRef}>
      <h3 className="modal-title">{t('confirmDeliveryTimeFreeModal.title')}</h3>
      <div className="modal-description">
        <p>
          {t('confirmDeliveryTimeFreeModal.label')} {date}{' '}
          {t('confirmDeliveryTimeFreeModal.from')} {hours[0]}{' '}
          {t('confirmDeliveryTimeFreeModal.to')} {hours[1]}
          {t('confirmDeliveryTimeFreeModal.confirm')}
        </p>
      </div>
      <div className="modal-button-container">
        <Button
          onClick={() => {
            close();
            onConfirm();
          }}
          label={t('confirmDeliveryTimeFreeModal.confirmation')}
          isPrimary
        />
        <div className="change-address-confirm-modal--exit-button">
          <Button
            onClick={close}
            label={t('confirmDeliveryTimeFreeModal.close')}
          />
        </div>
      </div>
    </Modal>
  );
});
